import { configureStore, combineReducers } from '@reduxjs/toolkit';
import userReducer from './user/userSlice';
import groupReducer from './group/groupSlice';
import deviceReducer from './device/deviceSlice';
import applicationReducer from './application/applicationSlice';
import advancedSearchReducer from './advancedSearch/advancedSearchSlice';
import delegationReducer from './delegation/delegationSlice';
import organizationReducer from './organization/organizationSlice';
import authReducer from './auth/authSlice';
import dashboardReducer from './dashboard/dashboardSlice';
import preferenceReducer from './preference/preferenceSlice';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const rootReducer = combineReducers({user: userReducer, group: groupReducer, device: deviceReducer, application: applicationReducer, advancedSearch: advancedSearchReducer, delegation: delegationReducer, organization: organizationReducer, auth: authReducer, preference: preferenceReducer, dashboard: dashboardReducer});

const persistConfig = {
    key: 'root',
    storage,
    version: 1,
    blacklist: ["dashboard"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
    devTools: false
});

export const persistor = persistStore(store);